/** Âge de la majorité */
export const ADULT_AGE = 18;

/**
 * Indique si une personne est mineure à la date donnée.
 * Une date de naissance absente ou invalide n'est pas considérée comme mineure, comme les dates par défaut
 * (01/01/1900, 01/01/1970) saisies quand le client ne souhaite pas communiquer la sienne.
 * @param birthDate Date de naissance au format `yyyy-MM-dd`
 * @param now Date de référence, aujourd'hui par défaut
 * @returns Vrai si la personne a moins de 18 ans
 */
export function isMinor(birthDate: string | null | undefined, now: Date = new Date()): boolean {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(birthDate ?? '');
  if (!match) {
    return false;
  }
  const [ year, month, day ] = match.slice(1).map(Number);
  const birth = new Date(Date.UTC(year, month - 1, day));
  if (birth.getUTCFullYear() !== year || birth.getUTCMonth() !== month - 1 || birth.getUTCDate() !== day) {
    return false;
  }
  // Majeur dès le jour des 18 ans (fuseau UTC pour éviter les décalages d'un jour)
  const adultDay = Date.UTC(year + ADULT_AGE, month - 1, day);
  const today = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());
  return today < adultDay;
}
